if (!customElements.get('category-slider-controller')) {
  class CategorySlider extends HTMLElement {
    constructor() {
      super();

      this.swiperInstance = null;
      this.spaceBetween = 2;
    }

    connectedCallback() {
      this.spaceBetween = this.getAttribute('data-space-between');
      this.initSwiper();
    }

    initSwiper() {
      if(!window.Swiper) {
        return null;
      }

      // 2026-11-01 "carousel is not scrolling/swiping": preventInteractionOnTransition dropped every
      // swipe made during the 300 ms slide animation (a second flick did nothing), and a trackpad
      // swipe is a wheel event Swiper ignored. Now: swipes always register, horizontal trackpad
      // and shift+wheel scroll it (vertical page scroll is left alone), and the cursor shows it drags.
      this.swiperInstance = new window.Swiper(this, {
        slidesPerView: 3.5,
        grabCursor: true,
        mousewheel: { forceToAxis: true, releaseOnEdges: true },
        freeMode: { enabled: true, sticky: false, momentumRatio: 0.6 },
        spaceBetween: this.spaceBetween,
        slidesOffsetAfter: 12,
        slidesOffsetBefore: 12,
        watchOverflow: true,
        pagination: {
          el: '.swiper-pagination',
          type: 'progressbar',
        },
        // Marcus Q121/Q125: 5.5 bigger cards at 1025+ (the half card is the only cue to drag), offsets 16, the brand gutter.
        breakpoints: {
          1025: {
            slidesPerView: 5.5,
            slidesOffsetAfter: 16,
            slidesOffsetBefore: 16,
          },
        },
      });
    }

    destroySwiper() {
      if (this.swiperInstance) {
        try {
          if (this.swiperInstance.destroyed) {
            console.info('Swiper already destroyed');

            this.swiperInstance = null;
            return null;
          }
          this.swiperInstance.destroy(true, true);
          this.swiperInstance = null;
        } catch (error) {
          console.error('Error destroying Swiper:', error);
          this.swiperInstance = null; // Fallback
        }
      } else {
        console.log('No Swiper instance to destroy');
      }
    }

    disconnectedCallback() {
      if (this.swiperInstance) {
        this.destroySwiper();
      }
    }
  }

  customElements.define('category-slider-controller', CategorySlider);
}
